import ExportHistory from './ExportHistory';

export function ViewAssetReports() {
  return <ExportHistory />;
}
